'use client';
import type {SxProps, Theme} from '@mui/material/styles';
import {AppIcon, FaCloseIcon} from '../icon';
import {IconButton, type IconButtonProps} from './IconButton';

type SxEntry = Exclude<SxProps<Theme>, readonly unknown[]>;

export interface CloseButtonProps {
  onClick: () => void;
  'aria-label'?: string;
  size?: number;
  sx?: IconButtonProps['sx'];
  className?: string;
}
export function CloseButton({onClick, 'aria-label': ariaLabel, size, sx, className}: CloseButtonProps) {
  return (
    <IconButton aria-label={ariaLabel} size={size} onClick={onClick} sx={sx} className={className}>
      <AppIcon
        icon={FaCloseIcon}
        sx={[
          {fontSize: '18px', color: theme => theme.palette.colors.icon.neutral.default},
          ...((Array.isArray(sx) ? sx : [sx]) as SxEntry[]),
        ]}
      />
    </IconButton>
  );
}

CloseButton.displayName = 'CloseButton';
